import React, { Component } from 'react';
import { BrowserRouter as Router,Route} from "react-router-dom";
import login from '../component/signup';
import Signin from '../component/signin';
import Evalution from '../component/evalution';
import couActStack from '../component/couActStack';
import DimenProb from '../component/DimenProb';
import Dashboard from '../component/dashboard';
import buyermotivation from '../component/buyermotivationparty';
import problemScored from '../component/problemScorecard';
import problemVaidation from '../component/problemVaidation';
import SolutionScoreCard from '../component/solutionScoreCard';
import CruxAllignment from '../component/cruxAllignment';
import CruxCompetetive from '../component/cruxCompetative';
import CruxImpact from '../component/cruxImpact'; 
import PurchDesAllignment from '../component/purchaseDesicionAllignemt';
import RevenewScore from '../component/revenewScore';
import SolutionRiskCoreCard from '../component/solutionRiskScore';
import FundingScore from '../component/fundingScore';
import marketingScore from '../component/marketingScore';
import PmcmAlligment from '../component/pmcmAllignment';
import DemandPeak from '../component/demandPeak';
import AdminDashboard from '../component/AdminDashboard';
import Home from '../component/home';
import Result  from '../component/result';

class RouterLink extends Component{


render(){


  return(
    <Router>
    
 
  <Route exact path='/' component={Home} />
    <Route exact path='/signin' component={Signin} />
    <Route exact path='/signup' component={login} />
    <Route exact path='/dashboard' component={Dashboard} />
    <Route exact path='/evalution' component={Evalution} />
    <Route exact path='/couActStack' component={couActStack} /> 
    <Route exact path='/DimenProb' component={DimenProb} />
    <Route exact path='/buyerMotivation' component={buyermotivation} />
    <Route exact path='/problemScorecard' component={problemScored} />
    <Route exact path='/problemValidation' component={problemVaidation} />
    <Route exact path='/solutionScorecard' component={SolutionScoreCard} />
    <Route exact path='/cruxCompetative' component={CruxCompetetive} />
    <Route exact path='/cruxAlligment' component={CruxAllignment} />
    <Route exact path='/cruxImpact' component={CruxImpact} />
    <Route exact path='/PurchseDescionAllignemt' component={PurchDesAllignment} />
    <Route exact path='/RevenewScore' component={RevenewScore} />
    <Route exact path='/SolutionRiskCoreCard' component={SolutionRiskCoreCard} />
    <Route exact path='/fundingScore' component={FundingScore} />
    <Route exact path='/marketingScore' component={marketingScore} />
    <Route exact path='/pmcm' component={PmcmAlligment} />
    <Route exact path='/demndPeak' component={DemandPeak} />
    <Route exact path='/result' component={Result} />
    <Route exact path='/adminDash' component={AdminDashboard} /> 




 </Router>



  )
}
}


export default RouterLink;
